import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererLink from "@/components/vehicle/list/cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "@/components/vehicle/list/cell-renderer/CellRendererStatus.vue";
import CellRendererProfile from "@/components/vehicle/list/cell-renderer/CellRendererProfile.vue";
import CellRendererActions from "@/components/vehicle/list/cell-renderer/CellRendererActions.vue";
import ResourceList from "@/components/resource/user-list/ResourceList.vue";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const resourceListMixin = {
	name: "ResourceList",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
					showButtonAdd: true,
					showButtonSelected: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		pagination: {
			type: Object,
			default: () => {
				return {
					next_page: 0,
					total_pages: 0,
					total_records: 0,
				};
			},
		},
		componentParent: {
			type: String,
			default: "RESOURCE_LIST",
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererLink,
		CellRendererStatus,
		CellRendererProfile,
		CellRendererActions,
		ResourceList,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			departmentFilter: {label: "All", value: "all"},
			searchQuery: [],
			searchQueryImporResource: "",
			currentPageLocal: 1,
			quantityElementPage: 10,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			infoSelected: null,
			isExactly: false,
			arrayInfo: [],
			showSelected: false,
			showSearch: false,
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererLink,
				CellRendererStatus,
				CellRendererProfile,
				CellRendererActions,
			},
			resourceListConfig: {
				rowSelection: "multiple",
				activeCheckbox: true,
				columns: ["identification", "name", "lastname", "username", "demand", "email", "alias", "status"],
				actionDropdown: false,
				btnAssigResources: true,
				popupMode: true,
				activeHeaderCheckboxSelection: true,
				tableOptions: false,
				showItemsPerPage: false,
				showBtnNewResource: false,
				showSelectedResource: true,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.getVehicles(page);
		},
		quantityElementPage() {
			this.getVehicles(1);
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = this.customConfig.filterHead !== undefined ? this.customConfig.filterHead : true;
			let columns = [
				{
					headerName: this.$t("Routing.Table.Identification"),
					field: "identification",
					width: 250,
					filter: filterHead,
					checkboxSelection: this.customConfig.activeCheckbox,
					headerCheckboxSelectionFilteredOnly: true,
					headerCheckboxSelection: this.customConfig.activeHeaderCheckboxSelection,
					cellRendererFramework: this.customConfig.activeLink ? "CellRendererLink" : null,
					pinned: this.customConfig.activeCheckbox ? "left" : "",
				},
				{
					headerName: this.$t("ResourceModule.Table.Name"),
					field: "name",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("ResourceModule.Table.Lastname"),
					field: "lastname",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("ResourceModule.Table.Username"),
					field: "username",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("ResourceModule.Table.Email"),
					field: "email",
					filter: filterHead,
					width: 250,
				},
				{
					headerName: this.$t("ResourceModule.Table.Status"),
					field: "status",
					filter: filterHead,
					width: 130,
				},
				{
					headerName: this.$t("ResourceModule.Table.Type"),
					field: "typology_name",
					filter: filterHead,
					width: 200,
				},
				{
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 120,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`ResourceModule.Table.${this.searchField}`);
		},
		listData() {
			return this.$store.state.vehicle.resourceListDatarutas;
		},
		getCheckedResourceDatarutas() {
			return this.$store.state.vehicle.checkedResourceDatarutas;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		getVehicles(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				quantity: this.quantityElementPage,
				role_name: ["EXECUTIVE", "SUPERVISOR"],
				match_filter: !this.isExactly,
				sort: "desc",
				order_by: ["id"],
			};
			this.$store
				.dispatch("vehicle/fetchDatarutasResource", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchVehicle() {
			const searchQueryList = this.searchQuery.map(({value}) => value);
			const dataPage = {
				identification: this.searchField === "Identification" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				lastname: this.searchField === "Lastname" ? searchQueryList : [],
				username: this.searchField === "Username" ? searchQueryList : [],
				email: this.searchField === "Email" ? searchQueryList : [],
				typology_name: this.searchField === "Type" ? searchQueryList : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "asc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("vehicle/fetchDatarutasResource", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		rowSelected(event) {
			const isSelected = event.node.isSelected();
			if (isSelected) {
				this.$store.commit("vehicle/ADD_VEHICLE_CHECKED_DATARUTAS", event.data);
			} else {
				this.$store.commit("vehicle/REMOVE_VEHICLE_CHECKED_DATARUTAS", event.data);
			}
		},
		onSelectionChanged() {},
		setDefaultSelectedRow() {
			const relatedIds = this.getCheckedResourceDatarutas;
			if (relatedIds.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIds.some((r) => r.id === node.data.id);
					node.setSelected(valid);
				});
			}
		},
		refreshVehicle() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.infoSelected = null;
			this.showSelected = false;
			this.showSearch = false;
			this.searchQuery = [];
			this.$store.commit("vehicle/REMOVE_ALL_VEHICLE_CHECKED_DATARUTAS");
			this.getVehicles(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		updateDemand(amount) {
			if (this.getCheckedResourceDatarutas.length > 0) {
				this.getCheckedResourceDatarutas.forEach((vehicle) => {
					this.listData.forEach((item) => {
						if (vehicle.id === item.id) item.demand = amount;
					});
				});
				this.gridApi.setRowData(this.listData);
				this.setDefaultSelectedRow();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_vehicle"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		getData(data) {
			this.arrayInfo = data.map((info) => {
				return {label: info.name, value: info.id};
			});
		},
		getDataCapacity(data) {
			this.arrayInfo = data.map((info) => {
				return {
					label: info.name,
					value: info.id,
					infoCapacity: {capacity_id: info.id, amount: info.resources != null ? info.resources[0].amount : 0},
				};
			});
		},
		selectedVehicles(initValue) {
			if (this.getCheckedResourceDatarutas.length >= initValue) {
				this.gridApi.setRowData(this.getCheckedResourceDatarutas);
				this.setDefaultSelectedRow();
				this.showSelected = true;
			}
		},
		removeChips() {
			this.infoSelected = null;
			this.showSelected = false;
			this.searchQuery = [];
			if (this.getCheckedResourceDatarutas.length > 0 && !this.showSearch) {
				this.gridApi.setRowData(this.listData);
				this.setDefaultSelectedRow();
			} else {
				this.showSearch = false;
				this.getVehicles(1);
			}
		},
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.componentParent != "OPTIMIZATION") this.getVehicles(1);
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_vehicle;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_vehicle;
		}
		this.$emit("gridApiEmit", this.gridApi);
	},
	beforeDestroy() {
		if (this.componentParent != "OPTIMIZATION") this.$store.commit("vehicle/REMOVE_ALL_VEHICLE_CHECKED_DATARUTAS");
	},
};
